import { Component, ViewChild, ViewEncapsulation, OnInit, ElementRef } from '@angular/core';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { KYMW2800Model } from './kymw2800.model';
import { OutputGPBudgetProgressFileService } from './api-services/output-gp-budget-progress-file.service';


/**
 * 週別部門別供給高GP予算進捗画面を管理するクラス
 *
 * @export KYMW2800Component
 * @class KYMW2800Component
 */
@Component({
  selector: 'app-kymw2800',
  templateUrl: 'kymw2800.component.html',
  styleUrls: ['kymw2800.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW2800Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  kymw2800Model: KYMW2800Model = new KYMW2800Model();

  @ViewChild('txti_lOrderCode', { static: true }) txti_lOrderCode: OrderCodeTextInputComponent;
  @ViewChild('txti_rOrderCode', { static: true }) txti_rOrderCode: OrderCodeTextInputComponent;

  /**
   *Creates an instance of KYMW2800Component.
   * @param {OutputGPBudgetProgressFileService} outputGPBudgetProgressFileService
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW2800Component
   */
  constructor(
    private outputGPBudgetProgressFileService: OutputGPBudgetProgressFileService,
    private fileDownloadConfirmService: FileDownloadConfirmService,
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  // eslint-disable-next-line
  public ngOnInit(): void {
    this.componentName = 'KYMW2800';
  }

  public printOutBtnClicked(): void {
    // check entities validation
    if (PlessViewUtilsSub.isEmpty(this.kymw2800Model.orderCodeFrom)) {
      this.dialogService.openAlertGetMessage('W0001', ['受注コード（From）']);
      return;
    }

    if (PlessViewUtilsSub.isEmpty(this.kymw2800Model.orderCodeTo)) {
      this.dialogService.openAlertGetMessage('W0001', ['受注コード（To）']);
      return;
    }

    if (!this.txti_lOrderCode.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('E0113', ['受注コード（From）']);
      return;
    }

    if (!this.txti_rOrderCode.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('E0113', ['受注コード（To）']);
      return;
    }

    if (Number(this.txti_lOrderCode.selectedOrderCode) > Number(this.txti_rOrderCode.selectedOrderCode)) {
      this.dialogService.openAlertGetMessage('E0125', ['受注コード（From）', '受注コード（To）']);
      return;
    }

    const vo = {
      orderCodeFrom: this.kymw2800Model.orderCodeFrom,
      orderCodeTo: this.kymw2800Model.orderCodeTo,
    };

    this.outputGPBudgetProgressFileService.execute(vo, (data) => {
      // ファイル名の設定
      const formatDate: string = PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss');
      const fileName = '週別部門別供給高GP予算_' + formatDate + '.txt';

      this.fileDownloadConfirmService.show(data.FileName, fileName);
    });
  }
}
